// extracted by mini-css-extract-plugin
export var text = "_an-0";